import { render, staticRenderFns } from "./ChooseConfiguration.vue?vue&type=template&id=949bea4a&scoped=true&"
import script from "./ChooseConfiguration.vue?vue&type=script&lang=js&"
export * from "./ChooseConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ChooseConfiguration.vue?vue&type=style&index=0&id=949bea4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949bea4a",
  null
  
)

export default component.exports